import * as I18n from 'i18n-js';
import * as React from 'react';
import { get } from 'lodash';

import { articlesPath } from '../../shared/url_helpers';
import RelatedArticles from '../../shared/related_articles';
import { V3 } from '../../api_request';

const ARTICLE_COUNT = 3;

interface IState {
  title?: string;
  articles: any[];
  action?: JSX.Element;
}

export default class RecentArticles extends React.Component<any, IState> {
  state = {
    articles: [],
  };

  componentDidMount() {
    this.fetchRelatedArticles();
  }

  getBackgroundImageStyle(article) {
    const src = get(article, 'photo');
    if (!src) return null;

    return { backgroundImage: `url(${src})` };
  }

  fetchRelatedArticles() {
    V3.get(
      articlesPath.expand({ per_page: ARTICLE_COUNT }),
    ).then((response) => {
      this.setState({ articles: response.articles });
    });
  }

  render() {
    return (
      <RelatedArticles
        articles={this.state.articles}
        heading={I18n.t('discovery.homepage.recentArticles')}
        action={this.props.action}
      />
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/recent_articles.tsx